<template>
  <div class="app-navbar-actions">

    <img :src="$store.state.profilePicture" style="    width: 40px;height: 40px;border-radius: 100%;" alt="">
    <profile-dropdown class="app-navbar-actions__item app-navbar-actions__item--profile">
      <span v-if="isAdmin==='1'">[管理员]</span><span v-else>[用户]</span> <span> {{ userName }}</span>
    </profile-dropdown>
  </div>
</template>

<script>
import LanguageDropdown from './dropdowns/LanguageDropdown'
import ProfileDropdown from './dropdowns/MobileProfileDropdown'
import NotificationDropdown from './dropdowns/NotificationDropdown'
import AuthConfig from '../../../../public/authConfig.json'

export default {
  name: "MobileNavbarAction",
  components: {
    //VaIconMessage,
    // SettingsDropdown,
    // ColorDropdown,
    // MessageDropdown,
    // NotificationDropdown,
    // LanguageDropdown,
    ProfileDropdown,
  },

  props: {
    userName: {
      type: String,
      default: '',
    },
    isTopBar: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isTopBarProxy: {
      get() {
        return this.isTopBar
      },
      set(isTopBar) {
        this.$emit('update:isTopBar', isTopBar)
      },
    },
    isAdmin() {
      return this.$store.state.isAdmin;
    }
  },
  methods: {
    openRPAPlatform() {
      window.open(AuthConfig.rpaUrl, '_blank');
      // window.location.href = this.$store.state.rpaUrl;
    }
  }
}
</script>

<style lang="scss">
.app-navbar-actions {
  display: flex;
  align-items: center;

  .va-dropdown__anchor {
    color: var(--va-primary);
    fill: var(--va-primary);
  }

  &__item {
    padding: 0;
    margin-left: 1.25rem;
    margin-right: 1.25rem;

    svg {
      height: 24px;
    }

    &:last-of-type {
      margin-right: 0;
    }

    &--profile {
      display: flex;
      justify-content: center;
      margin: auto 0 auto 1.25rem;
    }

    .va-dropdown-content {
      background-color: var(--va-white);
    }

    @media screen and (max-width: 768px) {
      margin-right: 0;

      &:first-of-type {
        margin-left: 0;
      }

      &--profile {
        position: absolute;
        right: 0.75rem;
        top: 1.25rem;
        height: fit-content;
        margin: auto;
      }
    }
  }
}
</style>